import type { ReactNode } from 'react';

interface EyebrowProps {
  children: ReactNode;
  className?: string;
}

export function Eyebrow({ children, className = '' }: EyebrowProps) {
  return (
    <span className={`inline-flex items-center gap-2 rounded-pill border border-border-soft bg-surface/70 px-4 py-2 text-[11px] uppercase tracking-[0.22em] text-ink-muted font-ui backdrop-blur-sm ${className}`}>
      {children}
    </span>
  );
}
